export function sanitizeRedirectPath(input: unknown): string | undefined {
  if (typeof input !== "string") return undefined;

  const trimmed = input.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) {
    return undefined;
  }

  try {
    const url = new URL(trimmed, "http://local.test");

    if (url.origin !== "http://local.test") {
      return undefined;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return undefined;
  }
}

export function toAbsoluteRedirectUrl(path: string): string {
  return new URL(path, window.location.origin).toString();
}
